import { render, staticRenderFns } from "./businessApplication.vue?vue&type=template&id=d70c8a24"
import script from "./businessApplication.vue?vue&type=script&lang=js"
export * from "./businessApplication.vue?vue&type=script&lang=js"
import style0 from "./businessApplication.vue?vue&type=style&index=0&id=d70c8a24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports